<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <form @submit.prevent="submitForm" name="form_chk" method="post">
        <div class="container">
          <div class="area_wrap">
            <div class="title_wrap">
              <h3>개인정보 입력</h3>
              <p class="warn">필수입력정보입니다.</p>
            </div>
            <div class="aw_context tel userInput">
              <div class="warnSpace">
                <p class="warn"  v-text="form.id.errorTxt" v-if="form.id.hasError"></p>
              </div>
              <div class="article require" :class="{errorLaise : form.id.hasError}">
                <div class="inputHeader">
                  <p>아이디</p>
                </div>
                <input type="text" placeholder="아이디를 입력해주세요." v-model="form.id.value" maxlength="21" @keyup="blurName()" @blur="blurName()" class="idInput"/>
              </div>
              <div class="warnSpace">
                <p class="warn"  v-text="form.mail.errorTxt" v-if="form.mail.hasError"></p>
              </div>
              <div class="article require half" :class="{errorLaise : form.mail.hasError}">
                <div class="inputHeader">
                  <p>이메일</p>
                </div>
                <div class="halfWrap">
                  <input type="text" v-model="mailInput.value" @keyup="blurMailInput()">
                  <span class="narrow">@</span>
                  <input type="text" v-model="mailInput2.value" @keyup="blurMailInput2()" @blur="blurMailInput2()"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnWrap before" :class="{visible : form.id.flag && form.mail.flag}">
          <button type="submit" :disabled="!checkAll()">비밀번호 찾기</button>
        </div>
        <!-- 요청모드 (필수 데이터) -->
        <input type="hidden" name="m" value="checkplusSerivce">
        <!-- 업체정보 암호화 데이터 -->
        <input type="hidden" name="EncodeData" :value="this.getIdentity">
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '입력한 값을 확인해 주세요.',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호 찾기',
        prevUrl: '/'
      },
      mailInput: {
        value: '',
        flag: false
      },
      mailInput2: {
        value: '',
        flag: false
      },
      form: {
        id: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        mail: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'getIdentity'
    ]),
    ...mapGetters('identity', [
      'getIsTemp'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_ID',
      'SET_MAIL'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapMutations('identity', [
      'SET_URL'
    ]),
    ...mapActions('identity', [
      'IS_TEMP'
    ]),
    ...mapActions([
      'PW_FIND_APPROVAL',
      'IDENTITY'
    ]),
    blurName () {
      console.log('ID blur 이벤트실행')
      this.form.id.flag = false
      this.checkName()
    },
    checkName () {
      console.log('ID check 내부 이벤트실행')
      if (this.form.id.flag) return true

      const userId = this.form.id.value.replace(/\s/gi, '')
      if (userId === '') {
        this.form.id.hasError = true
        this.form.id.errorTxt = '아이디를 입력해주세요.'
        return false
      }
      // const isEng = /^[A-Za-z0-9+]*$/
      // if (!isEng.test(userId)) {
      //   this.form.id.hasError = true
      //   this.form.id.errorTxt = '영문과 숫자를 혼용하여 입력해주세요'
      //   return false
      // }
      this.form.id.flag = true
      this.form.id.hasError = false
      this.form.id.errorTxt = ''
      return true
    },
    blurMailInput () {
      this.form.mail.flag = false
      this.checkMailInput()
    },
    checkMailInput () {
      if (this.form.mail.flag) return true
      const input = this.mailInput.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput.flag = true
      this.blurEmail()
      return true
    },
    blurMailInput2 () {
      this.form.mail.flag = false
      this.checkMailInput2()
    },
    checkMailInput2 () {
      if (this.form.mail.flag) return true
      const input = this.mailInput2.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput2.flag = true
      this.blurEmail()
      return true
    },
    blurEmail () {
      this.form.mail.flag = false
      this.checkEmail()
    },
    checkEmail () {
      if (this.form.mail.flag && this.mailInput.flag && this.mailInput2.flag) return true

      const email = this.mailInput.value + '@' + this.mailInput2.value
      this.form.mail.value = email
      if (email === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
      const isEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!isEmail.test(email)) {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일 형식에 맞지 않습니다.'
        return false
      }
      this.form.mail.flag = true
      this.form.mail.hasError = false
      this.form.mail.errorTxt = ''
      return true
    },
    checkAll () {
      return !!(this.form.id.flag && this.form.mail.flag)
    },
    submitForm () {
      if (this.checkAll()) {
        this.formAction()
      } else {
        if (!this.form.id.flag) {
          this.popupSet.content = '아이디를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.id.hasError = true
          this.form.id.errorTxt = '아이디를 확인해주세요.'
          // document.querySelector('.idInput').focus()
          return false
        }
        if (!this.form.mail.flag) {
          this.popupSet.content = '이메일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.mail.hasError = true
          this.form.mail.errorTxt = '이메일을 확인해주세요.'
          // document.querySelector('.mailInput').focus()
          return false
        }
      }
    },
    async formAction () {
      const btn = document.querySelector('.btnWrap button')
      btn.setAttribute('disabled', 'disabled')
      btn.parentNode.classList.remove('visible')
      try {
        const userData = {
          id: this.form.id.value,
          mail: this.form.mail.value
        }
        await this.IS_TEMP(userData)
          .then(async () => {
            if (this.getIsTemp.isCertificated === true) {
              console.log('getIsTemp:: ', this.getIsTemp.isCertificated)
              /* 인증회원 - 본인인증 페이지로 */
              await this.IDENTITY()
                .then(() => {
                  this.SET_ID(this.form.id.value)
                  this.SET_MAIL(this.form.mail.value)
                  const url = document.location.href
                  this.SET_URL(url)
                  this.SET_REFERRER(window.location.href)
                  localStorage.setItem('url', url)
                  sessionStorage.setItem('identityId', this.form.id.value)
                  this.fnPopup()
                })
            } else {
              /* 승인회원 or 예비회원 - 이메일 전송으로 */
              await this.pwFindApproval()
              this.SET_REFERRER(window.location.href)
            }
          })
      } catch (error) {
        this.SET_POPUP(true)
        if (error.data.response.message === 'Incorrect Token') {
          this.popupSet.content = '입력한 정보와 일치하는 회원이 없습니다.'
        } else {
          this.popupSet.content = errorParser.parse(error)
        }
      } finally {
        console.log('getIsTemp:: ', this.getIsTemp)
        btn.parentNode.classList.remove('visible')
        this.initForm()
      }
    },
    async pwFindApproval () {
      try {
        const userData = {
          id: this.form.id.value,
          mail: this.form.mail.value
        }
        await this.PW_FIND_APPROVAL(userData)
          .then(() => {
            this.SET_ID(this.form.id.value)
            sessionStorage.setItem('pwFindId', this.form.id.value)
            this.$router.push('/passwordFindApprovalDone')
          })
      } catch (error) {
        console.log('error :', error);
        console.log('임시회원 비밀번호 찾기 에러에 진입함!')
        if (error.status === 401) {
          await this.$router.push('/login')
        } else {
          if (error.data.response.message === 'Incorrect Token') {
            this.popupSet.content = '입력한 정보와 일치하는 회원이 없습니다.'
          } else {
            this.SET_POPUP(true)
            this.popupSet.content = errorParser.parse(error)
          }
        }
      } finally {
        const btn = document.querySelector('.btnWrap.before button')
        btn.parentNode.classList.remove('visible')
        this.initForm()
      }
    },
    initForm () {
      this.form.id.value = ''
      this.form.mail.value = ''
      this.mailInput.value = ''
      this.mailInput2.value = ''
      this.form.id.flag = false
      this.form.mail.flag = false
      this.mailInput.flag = false
      this.mailInput2.flag = false
    },
    nextDone () {
      this.$router.push({ name: 'idFindDone' })
    },
    fnPopup () {
      window.name = 'Parent_window'
      // window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
      document.form_chk.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb'
      document.form_chk.target = 'Parent_window'
      document.form_chk.submit()
      self.close()
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/login')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
